<div class="col-12  white-background common-border-radius accordian">
  <p-fieldset [toggleable]="true" icon ="fa fa-filter" [title] = "'label_filters'| translate"
  (onAfterToggle) = "onAfterToggle($event)" [collapsed] = "collapsed">
  <div class="col-12 no-pad">
    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>lbl_dispatch_zones</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="serviceCitiesOptions" [(ngModel)]="selectedDispatchAddress"
        (onChange)="changeFilter('selectedDispatchAddress',selectedDispatchAddress)" [filter]="true">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>lbl_pickup_location</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="pickupLocationsOptions" [(ngModel)]="selectedPickupLocation" [filter]="true"
        (onChange)="changeFilter('selectedPickupLocation',selectedPickupLocation)" [placeholder]="pickupDropPlaceHolder">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>lbl_drop_location</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="pickupLocationsOptions" [(ngModel)]="selectedDropLocation" [filter]="true"
        (onChange)="changeFilter('selectedDropLocation',selectedDropLocation)" [placeholder]="pickupDropPlaceHolder"></p-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_from_date_filter</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-calendar #rangePicker [(ngModel)]="fromDate" dateFormat="dd M yy" [showIcon]="true"
        readonlyInput = "true" (onSelect)="onSelectDates($event,'fromDate')"></p-calendar>
      </div>
    </div>
    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_to_date_filter</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-calendar #rangePicker [(ngModel)]="toDate" dateFormat="dd M yy" [showIcon]="true" [minDate]="minDate"
        readonlyInput = "true" (onSelect)="onSelectDates($event,'toDate')"></p-calendar>
      </div>
    </div>
  </div>

  <div class="col-12 no-pad">


    <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_status</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-multiSelect [options]="statusListFilterOptions" [(ngModel)]="selectedBookingStatus" maxSelectedLabels="0"
        (onChange)="changeFilter('selectedBookingStatus',selectedBookingStatus)" selectedItemsLabel = "{0} items">
        </p-multiSelect>
      </div>
    </div>


    <div class="col-12 md:col-2 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_sort_by_list</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="sortTypeOptions" [(ngModel)]="selectedSortType"
        (onChange)="changeFilter('selectedSortType',selectedSortType)">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-8">
      <div class="form-label">
        <label for="endtDate">&nbsp;</label>
      </div>
      <button [ngClass]="filterApplied? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton appRipple (click)="onclickFilterApply()" type="button" icon="fa fa-check"
        [label]="'label_apply' | translate"></button>
      <button pButton appRipple class="reset-btn" (click)="resetFilter()" type="button" icon="fa fa-undo"
        [label]="'label_reset' | translate"></button>
    </div>

  </div>
</p-fieldset>

  <div class="col-12">
    <app-mi-grid-v2 [url]="url" [columnDefs]="columns" [paginationPageSize]="paginationCount" [uniqId]="uniqId" [exportUrl]="exportUrl"
      [searchPlaceHolder]="searchPlaceHolder" appLogicalAccessProvider accessCode="VIEW_THIRD_PARTY_TRANSFER_BOOKINGS"
      accessGroupCode="CURRENT_BOOKINGS" (rowClickedEvent)="onRowClicked($event)" [overflowShow]="true"
      (totalCount)="totalCount($event)" rowSelection="multiple" (dropDownEvent)="changeBookingStatus($event)"
      (editClickEvent)="changeDispatchLocation($event)" divClass="mi-grid"
      [gridScrollHeight]="gridScrollHeight" [showActionLegend]="true"></app-mi-grid-v2>
  </div>
</div>

<p-sidebar *ngIf="hasShowDriverSideBar" [(visible)]="hasShowDriverSideBar" position="right" [showCloseIcon]="false"
  [style]="{width:'45em'}">
  <div class="notification-container">
    <div class="content">
      <app-sidebar-assign-driver [bookingDetail]="bookingDetails" (sideBarHide)="sideBarHideFromShaired()"
        fromComponent="thirdPartyComponent" (showThirdPartyPopUp)="showThirdPartyPopUp()"></app-sidebar-assign-driver>
    </div>
  </div>
</p-sidebar>

<p-dialog modal="true" position="center" autoResize="false"
  styleClass="assign-search dispatch-location-dialog-div" [(visible)]="bookingCancelsPopup"
  [contentStyle]="{'overflow':'auto','width':'700px','padding-top': '0px'}">
  <p-header class="key-text1">
    {{selectParkingLocationHeader}}
  </p-header>
  <div class="form-container scroll-bar-css scroll-dialog-div">
    <form class="col-12">
      <div class="form-field">
        <div class="form-control">
          <div class="col-12">
            <div class="col-12 md:col-12 lg:col-12 grid">
              <div class="col-3 md:col-3 lg:col-3 key-text" translate>label_parking_locations</div>
              <div class="col-3 md:col-4 lg:col-4 key-text" translate>ETA(Estimated Time Of Arrival)</div>
              <div class="col-3 md:col-2 lg:col-2 key-text" translate>label_distance</div>
              <div class="col-3 md:col-2 lg:col-2 key-text marg-l-8px" translate>grid_actions</div>
            </div>
            <div class="col-12 md:col-12 lg:col-12 ss1 grid" [ngClass]="selectedClass(eachLocation)"
              *ngFor="let eachLocation of dispatchLocations">
              <div class="col-3 md:col-3 lg:col-3" translate>{{eachLocation.displayAddress}}</div>
              <div class="col-4 md:col-4 lg:col-4" translate>{{eachLocation.etaString?eachLocation.etaString:'--'}}</div>
              <div class="col-2 md:col-2 lg:col-2" translate>
                {{eachLocation.distanceString?eachLocation.distanceString:'--'}}</div>
              <div class="col-1 md:col-1 lg:col-1 col-offset-1">
                <button appAccessProvider pButton appRipple type="button" label="Select" [disabled]="selectedClass(eachLocation)"
                  (click)="onSelectDispatchLocation(eachLocation)"></button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12  form-buttons">
      </div>
    </form>
  </div>
</p-dialog>

<app-merge-booking-popup
  (onMergeComplete)="onMergeComplete($event)"
  (onClose)="onMergePopupClose()">
</app-merge-booking-popup>